export const Role = {
  SUPERADMIN: 0,
  ADMIN: 1,
  USER: 2,
};

export const Action = {
  ADD: "ADD",
  WHITELIST: "WHITELIST",
  BLACKLIST: "BLACKLIST",
  REVOKE: "REVOKE",
  DELETE: "DELETE",
  UPDATE_DISPATCH: "DISPATCH",
  UPDATE_CONFIG: "INTERVAL",
};

export const PageSizeOptions = {
  pageSize: 8,
  options: [8, 16, 32],
};

export const Common = {
  SUCCESS: "Success",
  FAILED: "Failed",
  EMPTY: "List is empty",
};

export const PermissionActions = {
  VIEW: "view",
  EXPORT: "export",
  ANALYTICS: "analytics",
  SCHEDULE: "schedule",
  FILTER: "filter",
  DASHBOARD: "Dashboard",
  FLEETS: "Fleets",
  TASK_SCHEDULER: "Task Scheduler",
  OTA_UPDATE: "OTA Update",
  TRANSACTIONS: "Transactions",
};

export const Permissions = {
  fleets: {
    title: PermissionActions.FLEETS,
    actions: [
      { name: PermissionActions.VIEW, value: true },
      { name: PermissionActions.EXPORT, value: false },
    ],
  },
  taskSchedular: {
    title: PermissionActions.TASK_SCHEDULER,
    actions: [
      { name: PermissionActions.VIEW, value: true },
      { name: PermissionActions.EXPORT, value: false },
      { name: PermissionActions.SCHEDULE, value: false },
    ],
  },
  otaUpdate: {
    title: PermissionActions.OTA_UPDATE,
    actions: [
      { name: PermissionActions.VIEW, value: true },
      { name: PermissionActions.EXPORT, value: false },
      { name: PermissionActions.SCHEDULE, value: false },
    ],
  },
  transactions: {
    title: PermissionActions.TRANSACTIONS,
    actions: [
      { name: PermissionActions.VIEW, value: true },
      { name: PermissionActions.EXPORT, value: false },
      { name: PermissionActions.FILTER, value: false },
    ],
  },
};
